module.exports = __webpack_public_path__ + "static/media/livello9-logo.80b1512c.svg";